/**
 * API configuration for Spotlight frontend
 * Points to the spotlight-service backend
 */

const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://spotlight.livewello.com'

export const apiConfig = {
  baseURL: API_BASE_URL,
  endpoints: {
    spotlight: (slug: string) => `${API_BASE_URL}/api/v1/public/spotlight/${slug}`,
    directory: `${API_BASE_URL}/api/v1/public/directory`,
    directorySearch: `${API_BASE_URL}/api/v1/public/directory/search`,
    specialties: `${API_BASE_URL}/api/v1/public/directory/specialties`,
    feedback: {
      submit: `${API_BASE_URL}/api/v1/public/feedback/submit`,
      approved: (coachId: string) => `${API_BASE_URL}/api/v1/public/feedback/${coachId}/approved`,
    },
    ads: {
        list: `${API_BASE_URL}/api/v1/public/ads`,
        track: `${API_BASE_URL}/api/v1/public/ads/track`,
    },
    creative: {
        generate: `${API_BASE_URL}/api/v1/spotlight/creative/generate`,
        approve: `${API_BASE_URL}/api/v1/spotlight/creative/approve`,
    },
    onboarding: {
        basicSetup: `${API_BASE_URL}/api/v1/spotlight/onboarding/basic-setup`,
        generatePreview: `${API_BASE_URL}/api/v1/spotlight/onboarding/generate-preview`,
        visibilityScore: `${API_BASE_URL}/api/v1/spotlight/onboarding/visibility-score`,
        detailedInterview: `${API_BASE_URL}/api/v1/spotlight/onboarding/detailed-interview`,
        progress: `${API_BASE_URL}/api/v1/spotlight/onboarding/progress`,
        generateAssets: `${API_BASE_URL}/api/v1/spotlight/onboarding/generate-assets`,
        saveAssets: `${API_BASE_URL}/api/v1/spotlight/onboarding/save-assets`,
        dashboard: `${API_BASE_URL}/api/v1/spotlight/onboarding/dashboard`,
        targeting: `${API_BASE_URL}/api/v1/spotlight/onboarding/targeting`,
        targetingSearch: `${API_BASE_URL}/api/v1/spotlight/onboarding/targeting/interests`,
    },
    packs: {
        list: `${API_BASE_URL}/api/v1/spotlight/packs`,
        purchase: `${API_BASE_URL}/api/v1/spotlight/purchase`,
    },
    reviews: {
        googleSearch: `${API_BASE_URL}/api/v1/spotlight/reviews/google/search`,
        googleConnect: `${API_BASE_URL}/api/v1/spotlight/reviews/google/connect`,
        googleDisconnect: `${API_BASE_URL}/api/v1/spotlight/reviews/google/disconnect`,
        googleSync: `${API_BASE_URL}/api/v1/spotlight/reviews/google/sync`,
        google: `${API_BASE_URL}/api/v1/spotlight/reviews/google`,
    }
  },
}

export default apiConfig
